import React from 'react'
import Home from './Home'
import About from './About'
import Contact from './Contact'
import ProductDetail from './ProductDetail'
import Blog from './Blog'
import BlogArticle from './BlogArticle'
import OurTeam from './OurTeam'
import ScrollToTop from '../Components/ScrollToTop'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

function AppRoutes() {
  return (
    <div clasName="AppRoutes">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/product/:productId" element={<ProductDetail />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:articleId" element={<BlogArticle />} />
        <Route path="/team" element={<OurTeam />} />
      </Routes>
    </div>
  )
}

export default AppRoutes